import { render, staticRenderFns } from "./cardDistributAgent.vue?vue&type=template&id=ccac47be&scoped=true&"
import script from "./cardDistributAgent.vue?vue&type=script&lang=js&"
export * from "./cardDistributAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccac47be",
  null
  
)

export default component.exports